import { render, staticRenderFns } from "./PluginConfirmDialog.vue?vue&type=template&id=3c25ab9d&lang=true"
import script from "./PluginConfirmDialog.vue?vue&type=script&lang=js"
export * from "./PluginConfirmDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports